import React, { memo } from 'react';
import Buttons from './Buttons';
import PropTypes from "prop-types";

const ButtonsVariant = (props) => {
  let themeColor = "#232323"; // Default: Black
  let color = "#fff";         // Default: White
  let extraClass = "btn-fill bg-[#232323]";
  let customBorder = "border-[2px] border-black";
  let customHover = "";
  let customStates= " text-white focus:!bg-white hover:!text-black active:!bg-white focus:!text-black  active:!text-black ";

  if (props.variant === "whiteToBlack") {
    themeColor = "";
    color = "#232323";
    extraClass = "bg-btn text-[#232323]";
    customStates = "hover:!bg-black hover:!text-white focus:!bg-black focus:!text-white active:!bg-black active:!text-white focus:outline-none";
  }

  return (
    <Buttons
      {...props}
      className={`rounded-[50px] font-medium  font-serif uppercase transition-all duration-300 ${extraClass} ${customBorder} ${props.className || ''} ${customHover} ${customStates}`}
      themeColor={themeColor || undefined}
      color={color}
    />
  );
};

ButtonsVariant.defaultProps = {
  variant: "blackToWhite",
};

ButtonsVariant.propTypes = {
  variant: PropTypes.oneOf(["blackToWhite", "whiteToBlack"]),
  className: PropTypes.string,
};

export default memo(ButtonsVariant);
